import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ITableModel } from '../table/model/tableModel';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-generate-manual-loading-plan',
  templateUrl: './generate-manual-loading-plan.component.html',
  styleUrls: ['./generate-manual-loading-plan.component.scss']
})
export class GenerateManualLoadingPlanComponent implements OnInit,OnChanges {

  @Output() onCloseEvent = new EventEmitter<any>();
  @Input() Data: any;
  @Output() onSave = new EventEmitter<any>();

  tableDetails:ITableModel = {
    emptyDataMSg: "No Records Found.",
    isColumnNameShow: true,
    data: [],
    columnDetails: [
        { columnName: 'Trip No', dataFieldName: "TripNo" },
        { columnName: 'LR Number', dataFieldName: "LRNumber" },
        { columnName: 'Order No', dataFieldName: "OrderNo" },
        { columnName: 'EANCode', dataFieldName: "EANCode" },
        { columnName: 'Case Size', dataFieldName: "CaseSize",alignType:'right' },
        { columnName: 'MfgDate', dataFieldName: "MfgDate" },
        { columnName: 'ExpDate', dataFieldName: "ExpDate" },
        { columnName: 'MRP', dataFieldName: "MRP",alignType:'right' },
        { columnName: 'Qty', dataFieldName: "Qty",alignType:'right' },
        {
          columnName: "Confirm Qty", dataFieldName: "ConfirmQty", alignType: 'right', isInput: true,
          inputField: {
            placeholder: 'Enter Amount',
            formControlName: 'ConfirmQty',
            dataField: 'ConfirmQty',
            type: "number",
            alignType: 'right',
            isReadOnly: false
          }
        },
        { columnName: 'ExchangeRate', dataFieldName: "ExchangeRate",alignType:'right' },
        // { columnName: "Actions", dataFieldName: "actions", divType: "action" },
    ],
    actionList: [],
  };
  
  constructor(
    private toastr: ToastrService,
  ) { }

  ngOnInit() {
    this.tableDetails.data=this.Data;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['Data']) {
      this.tableDetails.data=this.Data;
    }
  }
  
  onCheckSelect({ event, row, index, type }) {
    if (type == 'Input') {
      var value = parseFloat(event);
      if (isNaN(value) || value <= 0) {
        this.toastr.warning('Value must be greater than 0','Warning');
        return;
      }
      this.tableDetails.data[index].ConfirmQty = value;
      console.log("this.tableDetails.ConfirmQty", this.tableDetails.data[index].ConfirmQty);
    }
  }

  close() {
    this.onCloseEvent.emit();
  }

  OnSaveClick(){
    this.onSave.emit(this.tableDetails.data);
  }
}
